module.exports = __webpack_public_path__ + "img/Crimen y Policial.12f5cacb.svg";